<template>
  <Form :method="method" :action="action" :form-data="form" @success="success">
    <template v-slot="{ errors, submitting }">
      <h3 class="text-gray-400 mb-4">Nieuwe notitie toevoegen</h3>
      <label class="block mb-3">
        <span class="block mb-1">Notitie</span>
        <BaseTextarea
          name="description"
          v-model="form.description"
          :error="errors.description"
          rows="10"
          placeholder="Typ hier je notitie"
          required
          v-focus
        />
      </label>
      <div class="block mb-3 max-w-2xl">
        <label v-if="note" for="reminder_at" class="block mb-1 flex items-center">
          Notitie met reminder op
        </label>
        <label v-else for="reminder_at" class="block mb-1 flex items-center">
          Wil je een reminder toevoegen?
          <BaseIcon
            name="help-circle"
            class="ml-2 text-blue-500"
            v-tooltip="'Voeg een datum toe waarop je herinnert wilt worden aan deze notitie. De notitie komt in de reminders lijst te staan.'"
          />
        </label>
        <div class="flex -mx-1">
          <div class="w-1/2 mx-1">
            <DatePicker
              name="reminder_at"
              id="reminder_at"
              v-model="form.reminder_at"
              :error="errors.reminder_at"
              placeholder="dd-mm-jjjj"
            />
          </div>
          <div class="w-1/2 mx-1">
            <BaseSelect
              v-show="form.reminder_at"
              name="reminder_for"
              v-model="form.reminder_for"
              :options="$store.getters.userOptions"
              required
            />
          </div>
        </div>
      </div>
      <div class="flex py-3">
        <button type="submit" class="btn btn-blue" :disabled="submitting">Opslaan</button>
        <button type="button" class="cancel" @click="close">Annuleren</button>
      </div>
    </template>
  </Form>
</template>

<script>
import Form from "@/components/Form";
import DatePicker from "@/components/DayPicker";

export default {
  inject: ["close"],

  props: {
    method: {
      type: String,
      default: "post"
    },
    action: {
      type: String,
      required: true
    },
    deal: {
      type: Object
    },
    note: {
      type: Object
    }
  },

  components: {
    Form,
    DatePicker
  },

  data() {
    return {
      form: {
        description: "",
        reminder_at: "",
        reminder_for: this.$store.state.settings.user.id,
        deal_id: this.deal ? this.deal.id : null
      }
    };
  },

  created() {
    if (this.note) {
      this.form.description = this.note.description;
      this.form.reminder_at = this.note.reminder_at;
      if (this.note.reminder_for)
        this.form.reminder_for = this.note.reminder_for.id;
    }
  },

  methods: {
    success(data) {
      this.$emit("success", data);
      this.close();
    }
  }
};
</script>
